
export const selectOptions = [
    { value: 'Fasting Glucose & HBA1C', label: 'Fasting Glucose & HBA1C' },
    { value: 'Hemogram', label: 'Hemogram' },
    { value: 'Urine Examination, Routine; URINE, R/E', label: 'Urine Examination, Routine; URINE, R/E' },
    { value: 'Thyroid function tests', label: 'Thyroid function tests' },
    { value: 'Liver & Kidney Panel', label: 'Liver & Kidney Panel' },
    { value: 'Iron & Lipid Panel', label: 'Iron & Lipid Panel' },
    { value: 'Lipid Profile', label: 'Lipid Profile' },
    { value: 'Vitamin D 25 – Hydroxy', label: 'Vitamin D 25 – Hydroxy' },
    { value: 'Apolipoproteins A1 & B', label: 'Apolipoproteins A1 & B' },
    { value: 'C-Reactive Protein, Cardio; HsCRP', label: 'C-Reactive Protein, Cardio; HsCRP' },
    { value: 'Cardio C-Reactive Protein', label: 'Cardio C-Reactive Protein' },
    { value: 'Vitamin B12; CYANOCOBALAMIN', label: 'Vitamin B12; CYANOCOBALAMIN' },
    { value: 'Vitamin B12', label: 'Vitamin B12' },
    { value: 'Physical Examination', label: 'Physical Examination' },
    { value: 'HbA1c :Glycosylated Hemoglobin', label: 'HbA1c :Glycosylated Hemoglobin' },
    { value: "Free Thyroxin(T4 free)", label: "Free Thyroxin(T4 free)" },
    { value: "Free Triodothyronine (T3)& TSH", label: "Free Triodothyronine (T3)& TSH" },
    { value: "Full Blood Count with Platelets", label: "Full Blood Count with Platelets" },
    { value: "Urinalysis & Pregnancy test", label: "Urinalysis & Pregnancy test" },
    { value: "Malaria Thick Smear", label: "Malaria Thick Smear" },
    { value: "Widal Test H & O", label: "Widal Test H & O" },
    { value: "Blood sugar & Urinalysis", label: "Blood sugar & Urinalysis" },
    { value: "Hepatitis B Screening", label: "Hepatitis B Screening" },
    { value: "Calcium", label: "Calcium" },
    { value: "Blood sugar , Group & Urinalysis", label: "Blood sugar , Group & Urinalysis" },
    { value: "Total Cholesterol & ECG", label: "Total Cholesterol & ECG" },
    { value: "Syphilis test", label: "Syphilis test" },
    { value: "HIV & Urinalysis", label: "HIV & Urinalysis" },
    { value: "Hepatitis B Rapid", label: "Hepatitis B Rapid" },
    { value: "Screen Hepatitis C (HCV)", label: "Screen Hepatitis C (HCV)" },
    { value: "Fasting Blood Glucose", label: "Fasting Blood Glucose" },
    { value: "Urinalysis, LFTs, RFTs & BPI", label: "Urinalysis, LFTs, RFTs & BPI" },
    { value: "Hb Electrophoresis & Blood Group", label: "Hb Electrophoresis & Blood Group" },
    { value: "Lipid Profile & Glycosylated Haemoglobin", label: "Lipid Profile & Glycosylated Haemoglobin" },
    { value: "Consultation, Physical Examination & Report", label: "Consultation, Physical Examination & Report" },
    { value: "Complete Medical & Physical Examination : Profile / Component -56", label: "Complete Medical & Physical Examination : Profile / Component -56" },
    { value: "Full Blood/Haemogram", label: "Full Blood/ Haemogram" },
    { value: "Urine Examination", label: "Urine Examination" },
    { value: "Hepatitis B Screening", label: "Hepatitis B Screening" },
    { value: "HIV 1/2 Screening & Lipid Profile", label: "HIV 1/2 Screening & Lipid Profile" },
    { value: "Liver Function test", label: "Liver Function test" },
    { value: "Kidney Panel & ECG", label: "Kidney Panel & ECG" },
    { value: "Vitamin B12: Cyanocobalamin", label: "Vitamin B12: Cyanocobalamin" },
    { value: "Vitamin D25 - Hydroxy", label: "Vitamin D25 - Hydroxy" },
    { value: "Hepatitis C & Stool Analysis", label: "Hepatitis C & Stool Analysis" },
    { value: "Lipid Profile & Cervical Cancer Screening", label: "Lipid Profile & Cervical Cancer Screening" },
    { value: "TSH,HIV, Malaria, Calcium& CEA", label: "TSH,HIV, Malaria, Calcium& CEA" },
    { value: "CA125-Ladies & CA 153", label: "CA125-Ladies & CA 153" },
    { value: "LFT, RFT, Urinalysis, TPHA & Uric Acid", label: "LFT, RFT, Urinalysis, TPHA & Uric Acid" },
    { value: "Vitamin D & Hepatitis B", label: "Vitamin D & Hepatitis B" },
    { value: "FBC, ECG, CA 199 & PSA-Men.", label: "FBC, ECG, CA 199 & PSA-Men." },
    { value: "Vit D25- Hydroxy & Apolipoproteins A1 &B", label: "Vit D25- Hydroxy & Apolipoproteins A1 &B" },
    { value: "Vitamin B12: Cyanocobalamin & Vitamin B12", label: "Vitamin B12: Cyanocobalamin & Vitamin B12" },
    { value: "Urinalysis, Prolactin, Testosterone & Progestterone", label: "Urinalysis, Prolactin, Testosterone & Progestterone" },
    { value: "FSH, LH & Estradiol.", label: "FSH, LH & Estradiol." },
    { value: "Liver Function Test & Cervical Cancer Screening", label: ". Liver Function Test & Cervical Cancer Screening" },
    { value: "Renal Function Test & Urinalysis", label: "Renal Function Test & Urinalysis" },
    { value: "CA-125", label: "CA-125" },
    { value: "Uric Acid", label: "Uric Acid" },
    { value: "TSH I Vitamin D", label: "TSH I Vitamin D" },
    { value: "Blood Sugar & Lipid Profile", label: "Blood Sugar & Lipid Profile" },
    { value: "Anti-CCD", label: "Anti-CCD" },
    { value: "Rheumatoid Factor", label: "Rheumatoid Factor" },
    { value: "CRP, Uric Acid & ANA", label: "CRP, Uric Acid & ANA" },
    { value: "Anti Streptolysin O (ASO)", label: "Anti Streptolysin O (ASO)" },
    { value: "Stool analysis", label: "Stool analysis" },
    { value: "Hepatitis A Screening", label: "Hepatitis A Screening" },
    { value: "Typhoid Screening", label: "Typhoid Screening" },
    { value: "Semen Analysis & Sperm Antibody (ASAB)", label: "Semen Analysis & Sperm Antibody (ASAB)" },
    { value: "Testostrone Creatinine & Cholesterol", label: "Testostrone Creatinine & Cholesterol" },
    { value: "Chlamydia IgM & IgG Prolactin", label: "Chlamydia IgM & IgG Prolactin" },
    { value: "LH & FSH", label: "LH & FSH" },
    { value: "HIV Testing", label: "HIV Testing" },
    { value: "Pap Smear 1 Slide & Mammogram", label: "Pap Smear 1 Slide & Mammogram" },
    { value: "CA-125 & CA-15.3", label: "CA-125 & CA-15.3" },
    { value: "CEA Consultation", label: "CEA Consultation" },
    {value: "Total PSA test & Alpha Fetoprotein", label: "Total PSA test & Alpha Fetoprotein"},
    {value: "Faecal Occult Blood", label: "Faecal Occult Blood"},
    {value: "CA-125, CA-15.3, CA-19.9, CEA & Beta HCG", label: "CA-125, CA-15.3, CA-19.9, CEA & Beta HCG"},
    {value: "Alpha Fetpprotein", label: "Alpha Fetpprotein"},
    {value: " PSA & CEA", label: " PSA & CEA"},
    {value: "CEA, Beta HCG & Prostate Ultra Sound Scan", label: " CEA, Beta HCG & Prostate Ultra Sound Scan"},
    {value: "CA-125 & CA-19.9", label: "CA-125 & CA-19.9"},
    {value: "Result within 12 hours", label: "Result within 12 hours"},
    {value: "Walk-In Test", label: "Walk-In Test"},
    {value: "Result within 6 hours", label: "Result within 6 hours"},
    {value: "Result within 15 minutes", label: "Result within 15 minutes"},
    {value: "Result within 24 hours", label: "Result within 24 hours"},
    {value: "Without Certificate", label: "Without Certificate"},
    {value: "Express Testing", label: "Express Testing"},
];

export const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: '.3rem',
    }),

    multiValue: (provided) => ({
        ...provided,
        borderRadius: '.5rem',
    }),

    multiValueRemove: (provided) => ({
        ...provided,
        borderRadius: '.5rem',
    }),

    placeholder: (provided) => ({
        ...provided,
        borderRadius: '.5rem',
    }),

    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        return {
            ...provided,
            opacity,
            transition,
        };
    },
};

export const covidServices = [];
